import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Button,
} from "@mui/material";
import { useState } from "react";
import { DialogProps } from "./types";

export interface PromptDialogPayload {
  msg: React.ReactNode;
  title?: React.ReactNode;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
}

export type PromptDialogProps = DialogProps<PromptDialogPayload, string | null>;
const PromptDialog = ({ open, payload, onClose }: PromptDialogProps) => {
  const [value, setValue] = useState("");

  return (
    <Dialog open={open} onClose={() => onClose(null)}>
      <DialogTitle>{payload.title ?? "Prompt"}</DialogTitle>
      <DialogContent>
        {payload.msg}
        <TextField
          fullWidth
          autoFocus
          margin="dense"
          variant="standard"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(null)}>
          {payload.cancelText ?? "Cancel"}
        </Button>
        <Button variant="contained" onClick={() => onClose(value)}>
          {payload.okText ?? "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PromptDialog;
